import { render } from "./NavbarOffCanvas.vue?vue&type=template&id=27b7524f"
import script from "./NavbarOffCanvas.vue?vue&type=script&lang=js"
export * from "./NavbarOffCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__